import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const PrincipalLogin = () => {
  const [principalId, setPrincipalId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  // ✅ If already logged in, redirect
  useEffect(() => {
    const token = localStorage.getItem("principalToken");
    if (token) {
      navigate("/principal");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://admin.stipsredu.in/principal/login",
        {
          principalId,
          password,
        }
      );

      // ✅ Store token
      localStorage.setItem("principalToken", res.data.token);

      // ✅ Redirect to dashboard
      navigate("/principal");

    } catch (error) {
      alert(error.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#112E65] to-[#1e3a8a] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">

        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#112E65] mb-2">
            Principal Login
          </h1>
          <p className="text-sm text-gray-500">
            Login credentials are provided by the Administration
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Principal ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Principal ID
            </label>
            <input
              type="text"
              value={principalId}
              onChange={(e) => setPrincipalId(e.target.value)}
              placeholder="Enter your Principal ID"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#112E65]"
              required
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#112E65]"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-3 text-sm text-[#112E65] font-medium"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            className="w-full py-3 bg-[#112E65] text-white rounded-lg font-semibold hover:bg-[#0d234d] transition"
          >
            Login
          </button>

        </form>

        <p className="text-xs text-center text-gray-400 mt-6">
          Unauthorized access is strictly prohibited
        </p>
      </div>
    </div>
  );
};

export default PrincipalLogin;